export default "__VITE_PUBLIC_ASSET__bd7cc35b__"